import React from "react";

/**
 * FormLabel - Standardised label with an icon prefix.
 *
 * Usage:
 *   <FormLabel icon="fas fa-table">Table Configuration</FormLabel>
 *   <FormLabel icon="fas fa-tags" required>Keywords</FormLabel>
 */
const FormLabel = ({ icon, children, required = false, className = "" }) => (
  <label className={`form-label fw-semibold text-dark ${className}`}>
    {icon && <i className={`${icon} text-primary me-2`}></i>}
    {children}
    {required && <span className="text-danger ms-1">*</span>}
  </label>
);

export default FormLabel;
